// extracted by mini-css-extract-plugin
export default {"transactionData":"TicketRefund_transactionData__zlk6p"};